import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-m2-df2-scaffold',
  template: `
    <p>
      m2-df2-scaffold works!
    </p>
  `,
  styles: []
})
export class M2Df2ScaffoldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
